import type { TechGroup } from "@/types/home";
import {
  AppWindow,
  Server,
  Smartphone,
  Cloud,
  Database,
  GitBranch,
  BrainCircuit,
} from "@/icons";

/** Technology stack grouped by discipline (not a logo wall). */
export const techGroups: TechGroup[] = [
  {
    category: "Frontend",
    icon: AppWindow,
    items: ["React", "TypeScript", "Next-gen SSR", "Tailwind", "Framer Motion"],
  },
  {
    category: "Backend",
    icon: Server,
    items: ["FastAPI", "Node.js", "Python", "GraphQL", "REST"],
  },
  {
    category: "Mobile",
    icon: Smartphone,
    items: ["React Native", "Expo", "Swift", "Kotlin"],
  },
  {
    category: "Cloud",
    icon: Cloud,
    items: ["AWS", "GCP", "Cloudflare", "Vercel"],
  },
  {
    category: "Database",
    icon: Database,
    items: ["PostgreSQL", "MongoDB", "Redis", "Elasticsearch"],
  },
  {
    category: "DevOps",
    icon: GitBranch,
    items: ["Docker", "Kubernetes", "CI/CD", "Terraform"],
  },
  {
    category: "AI",
    icon: BrainCircuit,
    items: ["OpenAI", "LangChain", "Vector DBs", "RAG pipelines"],
  },
];
